export const UnitModel = {
  id: "",
  name: "",
  sortform: "",
};

export class UnitDecorator {
  constructor(unit) {
    this.unit = unit;
  }

  toRequest() {
    return {
      id: this.unit.id,
      name: this.unit.name,
      sortform: this.unit.sortform,
    };
  }
}
